import React, {FC, ReactNode} from 'react';
import SidePanel from '@geomatico/geocomponents/Layout/SidePanel';
import {HORIZONTAL_DISPLACEMENT_PANEL, PANEL_WIDTH} from '@/config';
import SlideTransition from '@/components/SlideTransition';

//TYPES
export type PanelProps = {
  children: ReactNode,
  width: number
};

const Panel: FC<PanelProps> = ({children, width}) => {

  return <SlideTransition width={PANEL_WIDTH.parcel} show={true}>
    <SidePanel isOpen={true} widescreen={true} sx={styles(width).sidePanel}>
      {children}
    </SidePanel>
  </SlideTransition>;
};
export default Panel;

const styles = (width: number) => ({
  sidePanel: {
    '&.MuiDrawer-root': {
      height: '100%',
      top: 0,
      position: 'absolute'
    },
    '& .MuiDrawer-paper': {
      borderRadius: '8px',
      opacity: 1,
      position: 'relative',
      width: width,
      left: HORIZONTAL_DISPLACEMENT_PANEL,
      top: 'calc(28px + 50%)',
      transform: 'translateY(-50%)',
      maxHeight: 'calc(100% - 32px)',
      overflowY: 'auto',
      height: 'auto',
      p: 3
    }
  }
});

